import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getContacts = createSelector(getModel, (model) => model.contacts);

export const getIsFetchingContacts = createSelector(
    getContacts,
    (value) => value.isFetching,
);

export const getContactsData = createSelector(
    getContacts,
    (value) => value?.data?.data,
);

export const getContactsPagination = createSelector(
    getContacts,
    (value) => value?.data?.pagination,
);

export const getContactsErrors = createSelector(
    getContacts,
    (value) => value.errors,
);

export const getUsers = createSelector(getModel, (model) => model.users);

export const getUsersData = createSelector(getUsers, (model) => model.data);

export const getIsDownloading = createSelector(
    getModel,
    (model) => model.isDownloading,
);

export const getIsInitializing = createSelector(
    getModel,
    (model) => model.isInitializing,
);

export const getIsOpenReasignModal = createSelector(
    getModel,
    (model) => model.isOpenReasignModal,
);

export const getIsUploading = createSelector(
    getModel,
    (model) => model.isUploading,
);

export const getReasignInitialValues = createSelector(
    getModel,
    (model) => model.reasignInitialValues,
);

export const getShowEmptyState = createSelector(
    getModel,
    (model) => model.showEmptyState,
);
